import { remove } from 'lodash';
import shortID from 'shortid';

import { form } from 'src/stores';

import { RACE_RESULTS_FORM_ID } from '../constants';

export const handleAddItem = (scope: string) => () => {
  const data = form.fetchWithoutObservable<AnyObject[]>(RACE_RESULTS_FORM_ID, scope) || [];
  const newItem = { id: shortID() };

  form.onChange(RACE_RESULTS_FORM_ID, scope, [...data, newItem]);
};

export const handleDeleteItem = (scope: string, id: string) => () => {
  const data = form.fetchWithoutObservable<AnyObject[]>(RACE_RESULTS_FORM_ID, scope) || [];
  remove(data, (item) => item.id === id);

  form.onChange(RACE_RESULTS_FORM_ID, scope, data);
};

export const handleAfterSelectDistance = (prefix) => {
  cleanFields(prefix);
};

const cleanFields = (prefix) => {
  form.onChange(RACE_RESULTS_FORM_ID, `${prefix}.custom_fields`, []);
};
